import React, { useState, useRef } from "react";
import { Button,CircularProgress } from "@mui/material";
import DynamicTable from "../../../GlobalComponents/CustomComponant/DynamicTable";
export default function SBIDataImport() {
  const [processedLines, setProcessedLines] = useState([]);
  const fileInputRef = useRef(null);
 const [pageLoader, setPageLoader] = useState(false);

  // Helper function to extract numeric value from string
  const getNumeric = (str) => {
    return str.replace(/[^\d]/g, ''); // Extract digits only
  };

  // Helper function to check if a string starts with a numeric value
  const startsWithNumeric = (str) => {
    return /^\d/.test(str.trim()); // Check if the trimmed string starts with a digit
  };

  const handleFileChange = (event) => {
   
    const file = event.target.files[0];
    if (file) {
      setPageLoader(true)
      const reader = new FileReader();
      reader.onload = (e) => {
        const text = e.target.result;
        const lines = text.split("\n"); // Split content into lines

        let runDate = "";
        let procDate = "";

        // Extract RUN DATE and PROC DATE from the header lines
        lines.forEach((line) => {
          if (line.includes("RUN DATE:")) {
            // Extract RUN DATE value, starting after "RUN DATE:"
            runDate = line.split("RUN DATE:")[1].trim().split(" ")[0]; // Extract date portion
          }
          if (line.includes("PROC DATE:")) {
            // Extract PROC DATE value, starting after "PROC DATE:"
            procDate = line.split("PROC DATE:")[1].trim().split(" ")[0]; // Extract date portion
          }
        });

        // Process the transaction details from lines of fixed length 155 characters
        const transactionData = lines
          .filter((line) => line.length === 156 
          && startsWithNumeric(line.substring(0, 7)) 
         &&  line.substring(39, 45).includes("10 /10")
        
        ) // Filter lines with SRNO starting with numeric
          .map((line) => {
            let ChNO_TRNO = "";
            let SRNO = line.substring(0, 7).trim();
            let NAMEOFDEPOSITOR = line.substring(7, 39).trim();
            let HEADOFAC = line.substring(39, 45).trim();
            let AMOUNT = line.substring(45, 83).trim();
            let sign = line.substring(83, 84).trim();
            let amountSign = sign === "" ? 1 : -1;
            let PROGRESSIVE = line.substring(84, 108).trim();
            let JOURNALNO = line.substring(108, 120).trim();
            let CHLNNO = line.substring(120, 128).trim();
            let TELLER = line.substring(128, 148).trim();
            let TXNBRCD = line.substring(148, 156).trim();

            let TypeCode = "";

            // Determine ChNO_TRNO and TypeCode based on NAMEOFDEPOSITOR
            if (NAMEOFDEPOSITOR.startsWith("RS")) {
              let strArr = NAMEOFDEPOSITOR.split("/");
              ChNO_TRNO = strArr[1].replace("TR-", "").trim();
              TypeCode = "RS";
            } else if (NAMEOFDEPOSITOR.startsWith("RLY")) {
              TypeCode = "RLY";
            } else if (["CHA", "TRF", "C/C", "COU", "CLG"].some(prefix => NAMEOFDEPOSITOR.startsWith(prefix))) {
              ChNO_TRNO = getNumeric(NAMEOFDEPOSITOR);
              TypeCode = "CHA";
            } else if (NAMEOFDEPOSITOR.startsWith("NE") && !isNaN(NAMEOFDEPOSITOR[2])) {
              let strArr = NAMEOFDEPOSITOR.split("-");
              ChNO_TRNO = strArr[0].trim();
              TypeCode = "NE";
            } else if (NAMEOFDEPOSITOR.startsWith("NT")) {
              let strArr = NAMEOFDEPOSITOR.split("-");
              ChNO_TRNO = strArr[0].trim();
              TypeCode = "NT";
            } else if (NAMEOFDEPOSITOR.startsWith("PE")) {
              let strArr = NAMEOFDEPOSITOR.split("-");
              ChNO_TRNO = strArr[0].trim();
              TypeCode = "PE";
            } else if (NAMEOFDEPOSITOR.startsWith("PT")) {
              let strArr = NAMEOFDEPOSITOR.split("-");
              ChNO_TRNO = strArr[0].trim();
              TypeCode = "PT";
            } else if (["CON", "ILS", "HTP", "ADI"].some(prefix => NAMEOFDEPOSITOR.startsWith(prefix))) {
              let strArr = NAMEOFDEPOSITOR.split(",");
              ChNO_TRNO = strArr[2].trim();
              TypeCode = "CON";
            } else if (NAMEOFDEPOSITOR.startsWith("NB")) {
              let strArr = NAMEOFDEPOSITOR.split("-");
              ChNO_TRNO = strArr[0].replace("NB Fund Pay", "").trim();
              TypeCode = "NB";
            } else if (NAMEOFDEPOSITOR.startsWith("NEFT")) {
              ChNO_TRNO = NAMEOFDEPOSITOR.trim();
              TypeCode = "NEFT";
            } else {
              TypeCode = "UN";
            }

            ChNO_TRNO = ChNO_TRNO.trim() ? "04" + ChNO_TRNO : "";
            return {
              SRNO,
              NAMEOFDEPOSITOR,
              HEADOFAC,
              AMOUNT,
              PROGRESSIVE,
              JOURNALNO,
              CHLNNO,
              TELLER,
              TXNBRCD,
              RUN_DATE: runDate,
              PROC_DATE: procDate,
              ChNO_TRNO,
              TypeCode
            };
          });

        setProcessedLines(transactionData); // Update state with processed data
      };
      reader.readAsText(file); // Read file as text
      setPageLoader(false)
    }
   
  };

  const handleButtonClick = () => {
    fileInputRef.current.click(); // Trigger click on hidden file input
  };


  const processedHeaders = [
    'SRNO', 'NAMEOFDEPOSITOR', 'HEADOFAC', 'AMOUNT', 'PROGRESSIVE',
    'JOURNALNO', 'CHLNNO', 'TELLER', 'TXNBRCD', 'RUN DATE', 
    'PROC DATE', 'ChNO_TRNO', 'TypeCode',
  ];


  return (
    <div>

      {pageLoader && (
              <div className="loaderContainer">
                <CircularProgress />
              </div>
            )}
      <h1>Focal Bank (SBI) Data</h1>
      {/* Hidden file input */}
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        accept=".txt"
        style={{ display: "none" }}
      />
      {/* Button to trigger file input */}
      <Button onClick={handleButtonClick}>Select File</Button>
      {processedLines && processedLines.length > 0 && (
  <>
    <h3>Processed Data:</h3>
    <table >
      <thead>
        <tr>
          <th>SRNO</th>
          <th>NAMEOFDEPOSITOR</th>
          <th>HEADOFAC</th>
          <th>AMOUNT</th>
          <th>PROGRESSIVE</th>
          <th>JOURNALNO</th>
          <th>CHLNNO</th>
          <th>TELLER</th>
          <th>TXNBRCD</th>
          <th>RUN DATE</th>
          <th>PROC DATE</th>
          <th>ChNO_TRNO</th>
          <th>TypeCode</th>
        </tr>
      </thead>
      <tbody>
        {processedLines.map((item, index) => (
          <tr key={index}>
            <td>{item.SRNO}</td>
            <td>{item.NAMEOFDEPOSITOR}</td>
            <td>{item.HEADOFAC}</td>
            <td>{item.AMOUNT}</td>
            <td>{item.PROGRESSIVE}</td>
            <td>{item.JOURNALNO}</td>
            <td>{item.CHLNNO}</td>
            <td>{item.TELLER}</td>
            <td>{item.TXNBRCD}</td>
            <td>{item.RUN_DATE}</td>
            <td>{item.PROC_DATE}</td>
            <td>{item.ChNO_TRNO}</td>
            <td>{item.TypeCode}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </>
)}



    </div>
  );
}

 
